import { locale } from '@app/global/helpers';
import Modules from '@app/modules';
import { defineAsyncComponent } from 'vue';
Modules.register({
    namespace: 'RF/Scout24',
    blocks: {
        'scout24.marketplace': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Scout24" */ '@app/modules/Racerfish/Scout24/Blocks/marketplace.vue')),
        'scout24.search': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Scout24" */ '@app/modules/Racerfish/Scout24/Blocks/searchbar.vue')),
    },
    routes: [
        {
            path: `/${locale()}/vehicle/:id/:slug?`,
            component: defineAsyncComponent(() => import(
            /* webpackChunkName: "Evolve-Scout24VehicleController" */
            '@app/modules/Racerfish/Scout24/VehicleController.vue')),
        },
    ]
});
